import script from "./PosteLivraisonListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PosteLivraisonListModal.vue?vue&type=script&setup=true&lang=js"

import "./PosteLivraisonListModal.vue?vue&type=style&index=0&id=3efc90f1&lang=scss"

const __exports__ = script;

export default __exports__